import axios from "../axiosInstance";
import { UnenrollRequest } from "./types";

/**
 * Unenroll an employee from a learning path
 * Soft-deletes enrollment by setting status to 'inactive'
 * Preserves all progress data for historical records
 *
 * @param enrollmentId - ID of the enrollment to unenroll
 * @param request - Optional request body with reason for audit trail
 * @returns Promise<void> - No response body on successful 204 No Content
 * @throws 400 Bad Request - Enrollment is already inactive
 * @throws 403 Forbidden - Insufficient permissions (requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN)
 * @throws 404 Not Found - Enrollment not found
 */
export const unenrollLearningPath = async (
  enrollmentId: number,
  request?: UnenrollRequest,
): Promise<void> => {
  await axios.delete(`/api/enrollments/${enrollmentId}`, {
    data: request,
  });
};
